<!-- Generated by scripts/generate-icons.mjs — do not edit by hand. -->
<script>
  import Icon from '../../components/Icon.svelte';

  let props = $props();
</script>

<Icon name="Banknote" {...props} />
